import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FavoriteOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"favorite_outline"}/>
}
